import { useState, useEffect } from "react";
import { connect, useSelector, useDispatch } from "react-redux";
import PropTypes from "prop-types";
import CountUp from "react-countup";
import moment from "moment";
import { getAllActiveVehicles } from "../../../actions/admin/vehicle";
import { getDrivers } from "../../../actions/admin/driver";
import { getAllUsersAdmin } from "../../../actions/auth";
import { getBookingChartData } from "../../../actions/admin/booking";
import AdminPage from "../_components/AdminPage";
import MonthlyBookingsChart from "./_components/MonthlyBookingsChart";

const StatCard = ({ value, label }) => (
  <div className="tw:flex tw:flex-col tw:gap-2 tw:rounded-[5px] tw:border tw:border-[#E6E6E6] tw:bg-white tw:px-[24px] tw:py-[22px]">
    <span className="tw:text-[28px] tw:font-semibold tw:leading-none tw:!text-[#282828]">
      <CountUp start={0} end={value || 0} duration={1.75} separator="," />
    </span>
    <span className="tw:text-[14px] tw:leading-[20px] tw:!text-[#7C7B7B]">{label}</span>
  </div>
);

const AdminDashboard = () => {
  const dispatch = useDispatch();
  const driver = useSelector((state) => state.driver);
  const { drivers } = driver;
  const auth = useSelector((state) => state.auth);
  const { users } = auth;
  const [activeVehicles, setActiveVehicles] = useState(0);
  const [bookingsThisMonth, setBookingsThisMonth] = useState(0);

  useEffect(() => {
    dispatch(getDrivers());
    fetchActiveVehicles(activeVehicleCallBackFunc);
    dispatch(getAllUsersAdmin());
  }, [dispatch]);

  // The card is the chart's own current-month column: same endpoint, same
  // aggregation, windowed to one month. Reading it from anywhere else drifts —
  // the booking list filters on the trip date, not the date the booking was made.
  useEffect(() => {
    const fetchBookingsThisMonth = async () => {
      const month = moment().format("MM/YYYY");
      const response = await getBookingChartData(
        "bar-booking-monthly",
        `?startMonthYear=${month}&toMonthYear=${month}`
      );
      const current = response?.chartData?.[0];
      setBookingsThisMonth((current?.confirmed || 0) + (current?.cancelled || 0));
    };

    fetchBookingsThisMonth();
  }, []);

  const fetchActiveVehicles = async (callback) => {
    const data = await getAllActiveVehicles();
    callback(data);
  };

  const activeVehicleCallBackFunc = (data) => {
    setActiveVehicles(data?.length);
  };

  return (
    <AdminPage title="Dashboard">
      <div className="tw:mt-[32px] tw:grid tw:grid-cols-1 tw:gap-3 tw:md:grid-cols-2 tw:xl:grid-cols-4">
        <StatCard value={bookingsThisMonth} label="bookings this month" />
        <StatCard value={users?.length} label="total users" />
        <StatCard value={activeVehicles} label="active vehicles" />
        <StatCard value={drivers?.filter((i) => i.isactive === true).length} label="active drivers" />
      </div>

      <MonthlyBookingsChart />
    </AdminPage>
  );
};

AdminDashboard.propType = {
  isAuthenticatedAdmin: PropTypes.bool,
};

const mapsStateToProps = (state) => ({
  isAuthenticatedAdmin: state.auth.isAuthenticatedAdmin,
});

export default connect(mapsStateToProps)(AdminDashboard);
